export enum Routes {
  createEvent = '/create-event',
  registeredMembers = '/events/:id/registered-members',
  confirm = '/confirm',
  landing = '/',
  main = '/main',
  reg = '/reg',
  withoutEmail = '/without-email',
  events = '/events',
  event = '/events/:id',
  myEvents = '/my_events',
  myEvent = '/my_events/:id',
  registration = '/registration',
  registrationOperator = '/registration-of-operator',
  editEvent = '/events/:id/edit-event',
  manageGroups = '/events/:id/manage-groups',
  createGroups = '/events/:id/create-groups',
  students = '/students',
  profile = '/profile/:id',
  results = '/events/:eventId/results',
  result = '/events/:eventId/results/:userId',
  editResult = '/events/:eventId/results/:userId/edit-result',
  agreement = '/agreement',
  check = '/check',
  createLocation = '/directories/locations/create-location',
  locations = '/directories/locations',
  createGlobalEvent = '/create-global-event',
  editGlobalEvent = '/global-events/:id/edit-global-event/',
  globalEvents = '/global-events',
  teams = '/teams',
  studentsPhotos = '/students_photos',
  combineEvents = '/directories/combine_events',
  createCombineEvent = '/directories/combine_events/create',
  editCombineEvent = '/directories/combine_events/:id/edit',
  logs = '/logs',
  users = '/users'
}

export enum RouteRoles {
  default = 'default',
  withoutFullProfile = 'withoutFullProfile',
  student = 'student',
  schoolAndUniversity = 'schoolAndUniversity',
  operator = 'operator',
  testOperator = 'testOperator',
  parent = 'parent'
}
